export default __webpack_public_path__ + "static/media/components_example.ecdaafd4.PNG";